
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

export const useAccountDeletion = () => {
  const [open, setOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [reason, setReason] = useState("");
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleDeleteAccount = async () => {
    try {
      setIsDeleting(true);

      // Get the current user
      const { data: { session } } = await supabase.auth.getSession();
      
      if (!session) {
        throw new Error("No active session found");
      }

      const userId = session.user.id;

      // Call the account deletion edge function
      const { data, error } = await supabase.functions.invoke('account-deletion', {
        body: {
          userId,
          feedback,
          reason
        }
      });
      
      if (error) {
        throw error;
      }

      // Show success message
      toast({
        title: "Account deleted",
        description: "Your account has been successfully deleted.",
      });

      // Navigate to the homepage
      navigate("/");
    } catch (error) {
      console.error("Error deleting account:", error);
      
      // Handle rate limiting errors specifically
      if (error.message?.includes("Rate limit exceeded")) {
        toast({
          title: "Too many requests",
          description: "Please wait before trying again.",
          variant: "destructive",
        });
      } else {
        toast({
          title: "Error",
          description: "There was a problem deleting your account. Please try again later.",
          variant: "destructive",
        });
      }
    } finally {
      setIsDeleting(false);
      setOpen(false);
    }
  };

  return {
    open,
    setOpen,
    isDeleting,
    feedback,
    setFeedback,
    reason,
    setReason,
    handleDeleteAccount
  };
};
